import React, { useState } from "react";
import { paymentsApi } from "../../api/auctiongate.js";
import { useAuth } from "../../auth/useAuth.js";

const AUCTIONS = [
  { value: "1", label: "IAAI (1)" },
  { value: "2", label: "Copart (2)" },
  { value: "11", label: "IAAI Canada (11)" },
  { value: "14", label: "Copart Canada (14)" },
];

export default function Payments() {
  const { user } = useAuth();
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const f = new FormData(e.currentTarget);
    setBusy(true);
    setMsg(null);
    setErr(null);
    try {
      const body = {
        auction_id: f.get("auction_id"),
        lot_number: f.get("lot_number"),
        vin: f.get("vin") || "",
        buyer_id: f.get("buyer_id"),
        amount: f.get("amount"),
        user_id: user?.companyId || "",
        sub_bidder_id: user?.id || "",
      };
      const r = await paymentsApi.save(body);
      setMsg(r?.message || "Saved.");
    } catch (e2) {
      setErr(e2?.message || "Failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card">
      <div className="card__title">
        Payments (log entry)
        <span className="badge">purchased-lots-log</span>
      </div>
      <form className="stack" onSubmit={submit}>
        <div className="row">
          <select name="auction_id" defaultValue="2" style={input}>
            {AUCTIONS.map((a) => (
              <option key={a.value} value={a.value}>
                {a.label}
              </option>
            ))}
          </select>
          <input name="lot_number" placeholder="Lot number" required style={input} />
          <input name="vin" placeholder="VIN (optional)" style={input} />
        </div>
        <div className="row">
          <input name="buyer_id" placeholder="Buyer id" required style={input} />
          <input name="amount" placeholder="Amount (USD)" type="number" required style={input} />
        </div>
        <button className="btn btn-primary" disabled={busy || !user?.id}>
          {busy ? <span className="loader" /> : "Save payment"}
        </button>
        {err && <div className="login-error">{err}</div>}
        {msg && <div className="small" style={{ color: "var(--color-success)" }}>{msg}</div>}
      </form>
    </div>
  );
}
const input = {
  padding: "8px 10px",
  border: "1px solid var(--color-border-input)",
  borderRadius: 8,
  fontSize: 13,
  flex: 1,
  minWidth: 120,
};
